
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-linejoin":"round","stroke-width":"3","d":"M32.482 12.346a71.576 71.576 0 011.204 1.627s11.02 15.52 11.24 24.535c-.122 3.445-1.56 6.451-3.806 8.619a12.437 12.437 0 01-8.66 3.496 12.437 12.437 0 01-8.66-3.496 12.437 12.437 0 01-3.805-8.53c-.03-9.08 11.263-24.638 11.263-24.638s.444-.612 1.224-1.613z"}}),_c('g',{attrs:{"transform":"translate(21 14)"}},[_c('path',{attrs:{"fill":"#D2EDF3","stroke":"#333","d":"M22.426 24.544a10.973 10.973 0 01-21.932 0C.466 15.817 11.467.847 11.467.847s10.747 14.97 10.959 23.697z"}}),_c('path',{attrs:{"fill":"#333","stroke":"#333","d":"M11.382 31.068a4.11 4.11 0 01-4.321-3.7.184.184 0 01.367 0 3.742 3.742 0 004.01 3.39 3.742 3.742 0 004.011-3.39.184.184 0 11.368 0 4.11 4.11 0 01-4.435 3.7h0z"}}),_c('ellipse',{attrs:{"cx":"15.972","cy":"20.675","fill":"#333","rx":"2.217","ry":"3.206"}}),_c('ellipse',{attrs:{"cx":"16.537","cy":"20.463","fill":"#FFF","rx":"1","ry":"1.186"}}),_c('circle',{attrs:{"cx":"15.534","cy":"21.663","r":"1","fill":"#FFF"}}),_c('ellipse',{attrs:{"cx":"7.005","cy":"20.675","fill":"#333","rx":"2.217","ry":"3.206"}}),_c('ellipse',{attrs:{"cx":"7.569","cy":"20.463","fill":"#FFF","rx":"1","ry":"1.186"}}),_c('circle',{attrs:{"cx":"6.567","cy":"21.663","r":"1","fill":"#FFF"}})])])])
          )
        }
      }
    